import React from 'react';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import 'rc-dropdown/assets/index.css';

const groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

function getFechaFormateada(stringFecha) {

    const dateArr = stringFecha.split('T');
    const fechaStr = dateArr[0].split("-");    
    const anioFormateado = fechaStr[2] + "/" + fechaStr[1] + "/" + fechaStr[0];    

    return {
        anio: anioFormateado,
        hora: dateArr[1]
    };
}

function getEstadoAnterior(estado, estados, siguientes) {

    if (estados.length === 0 || siguientes == undefined || siguientes.length === 0)
        return "";

    let anterior = null;
    const estadoFind = estados.find(e => e.Descripcion == estado);
    const siguienteFind = siguientes.find(s => s.DeliveryEstadoId == estadoFind.Id);   

    if (siguienteFind !== undefined && siguienteFind.AnteriorDeliveryEstadoId !== null)
        anterior = estados.filter(e => e.Id === siguienteFind.AnteriorDeliveryEstadoId);

    if (anterior === null)
        return "No posee estados anteriores";

    const anteriorDescripcion = anterior[0].Descripcion;

    return anteriorDescripcion;
}

const OverlayMenu = ({ nombre, estadoAnterior, fecha, fechaUltimoEstado }) => {

    const arrayFecha = getFechaFormateada(fecha);
    const arrayFechaUltimoEstado = getFechaFormateada(fechaUltimoEstado);

    return (
    <div className="DeliveryTarjetas-DropdownEstadoInfo">
        <p>Solicitud creada por {nombre} el {arrayFecha.anio}.</p>
        <p>Estado anterior:</p>
        <span className="label label-primary LabelEstadoTarjetas">{estadoAnterior}</span>
        <p>Estado modificado el {arrayFechaUltimoEstado.anio}. </p>
    </div>
    );
}


const EstadoInfoDropdown = ({ text, row, estados, siguientes }) => {

    let cssClass = "label LabelEstadoTarjetas";

    if (text.trim().toLowerCase() === "entregada")
        cssClass = "label LabelEstadoTarjetas";

    let siguientesEstados = null;

    if (siguientes !== null && siguientes != undefined && siguientes.length > 0)
        siguientesEstados = siguientes.filter(p => p.ProductoId === row.productoId);

    const estadoAnterior = getEstadoAnterior(row.estado, estados, siguientesEstados);
    const menu = <OverlayMenu nombre={row.nombre} estadoAnterior={estadoAnterior} fecha={row.FechaRespuesta} fechaUltimoEstado={row.FechaUltimoEstado} />

    return (
        <Dropdown
            trigger={['click']}
            overlay={menu}
            animation="slide-up"
        >
            <div className={cssClass}>
                <label>{text}</label>
            </div>
        </Dropdown>
    );

}

export default EstadoInfoDropdown;